import { create } from 'zustand'
// import { persist } from 'zustand/middleware'
import { defPath } from '../config/defPath'

import { TriviaData } from '../config/types/triviaTypes'

const URL_GET_QUESTIONS = `${window.location.origin}/aguila/copaamerica/assets-trivia`
const URL_POST_QUESTIONS = `${window.location.origin}/aguila/copaamerica/results-trivia`

interface TriviaState {
  trivia: TriviaData;
  currentQuestion: number;
  fetchQuestions: () => Promise<void>;
  selectAnswer: (questionId: string, answerId: string) => void;
  answers: any;
  goNextQuestion: () => Promise<void>;
  sendTrivia: (payload: any) => Promise<void>;
  updateTime: (time: number) => void
  currentTime: number
  result: {}
  isResult: boolean
  audio: any
  nowTime: number
}

let timer:any
let isSend:boolean = false

function startTimer(time: number) {
  timer = setInterval(() => {
    if (time === 0) {
      clearInterval(timer)
      return
    }
    time -= 1000
    useTriviaAmerica.getState().updateTime(time)
  }, 1000)
}

export const useTriviaAmerica = create<TriviaState>((set, get) => {
  return {
    trivia: {
      milliseconds: 0,
      maxquestions: 0,
      questions: [],
      prefix: '',
      results: {
        title: {
          value: '',
          format: ''
        },
        copy: {
          value: '',
          format: ''
        },
        button: {
          uri: '',
          title: '',
          options: []
        }
      },
      code: 0,
      tapa: '',
      copy_award: {
        value: '',
        format: ''
      },
    },
    currentQuestion: 0,
    answers: {},
    currentTime: 0,
    result: {},
    isResult: false,
    audio: new Audio(`${defPath}/assets/sounds/countdown.mp3`),
    nowTime: 0,

    fetchQuestions: async () => {
      const { audio, nowTime, trivia } = get()

      const urlParams = new URLSearchParams(window.location.search);
      const id = urlParams.get("id");      

      if (id === null) {
        window.location.href = `${window.location.origin}/estadio-aguila`
        return
      }

      fetch(URL_GET_QUESTIONS, {
        method: "POST",
        body: JSON.stringify({ id })
      })
        .then(res => res.json())
        .then(data => {
          if (data.code === 0) {
            let redirect = "?redirect=/estadio-aguila/aguila-millonaria/trivia?id=" + id
            window.location.href = `${window.location.origin}/estadio-aguila/iniciar-sesion` + redirect
          }
  
          if (data.code === 1) window.location.href = `${window.location.origin}/aguila-millonaria`

          if (data.code === 2) {
            console.log(data)
            set({ trivia: data })
            set({nowTime : new Date().getTime()})
            startTimer(data?.milliseconds)

            if(audio.duration > 0) {
              audio.play()
              audio.loop = true;
            }
          }
        })
    },

    selectAnswer: (questionId: string, answerId: string) => {
      const { answers } = get()
      let obj: any = new Object()
      obj[questionId] = answerId

      // PRIMERA RESPUESTA
      if (Object.keys(answers).length === 0) {
        set({ answers: obj })
        return
      }

      set({ answers: { ...answers, ...obj } })
    },

    goNextQuestion: async () => {
      const { answers, sendTrivia, currentQuestion, trivia, currentTime, nowTime } = get()
      const nextQuestion = currentQuestion + 1

      if (Object.keys(answers).length === 0) return

      if (nextQuestion < trivia.questions.length) {
        set({ currentQuestion: nextQuestion })
      }

      if (nextQuestion === trivia.questions.length ) {
        let finishTime = new Date().getTime() - nowTime

        trivia.milliseconds >= finishTime ? set({ currentTime:  finishTime}) : set({ currentTime:  trivia.milliseconds})

        const payload = {
          prefix: trivia.prefix,
          left_time: trivia.milliseconds >= finishTime ? trivia.milliseconds - finishTime : 0,
          tapa: trivia.tapa,
          answers: answers
        }
        clearInterval(timer)
        sendTrivia(payload)
      }
    },

    updateTime: async (time) => {
      const { answers, trivia, isResult, sendTrivia  } = get()
      
      if (time === 0 && !isResult) {
        const payload = {
          prefix: trivia.prefix,
          left_time: 0,
          tapa: trivia.tapa,
          answers: answers
        }

        set({ currentTime:  trivia.milliseconds})

        sendTrivia(payload)
      }
    },

    sendTrivia: async (payload:any) => {
      if(isSend) return

      isSend = true

      const { audio, trivia } = get()

      const urlParams = new URLSearchParams(window.location.search);
      const id = urlParams.get("id");

      if (id === null) {
        window.location.href = `${window.location.origin}/estadio-aguila`
        return
      }

      fetch(URL_POST_QUESTIONS, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({id, ...payload})
      }).then(res => res.json())
        .then(data => {
          if(audio.duration > 0) {
            audio.pause()
          }

          if (data.code === 2) {
            set({ result: data })
            set({ isResult: true })
            return
          }

          if (data.code === 0) window.location.href = `${window.location.origin}/estadio-aguila/iniciar-sesion`

          if (data.code === 1) window.location.href = `${window.location.origin}/estadio-aguila`

        })
        .catch(err => {
          // console.log(err)
          set({
            result: {
              additional: "",
              code: 2,
              correct: 0,
              points: 0
            }
          })
          set({ isResult: true })
        })
        .finally(() => {
          isSend = false
        })
    }
  }
})
